<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Ken N Kamoche was born and raised in Kenya. He was educated at the University of Nairobi and the University of Oxford. He is a management academic, occasional newspaper columnist and writer of fiction. Ken’s collection of short stories, <em>A Fragile Hope</em> (Salt, 2007), was shortlisted for the Commonwealth First Book Award. After travelling frequently to Asia, Ken took up a job in Hong Kong in 1998 supposedly for two years. The two years soon turned into ten, involved extensive travel up and down China, and ultimately inspired this novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5eba169a